import React from 'react';
import {useTheme} from "@mui/material";

const CircularProgressSvg = () => {
    const theme = useTheme();
    return (
        <svg style={{height: 0}}>
            <defs>
                <linearGradient id='circularProgressGradient' x1='0%' y1='0%' x2='0%' y2='100%'>
                    <stop offset='0%' stopColor={theme.palette.secondary.main}/>
                    <stop offset='100%' stopColor={theme.palette.accent.main}/>
                </linearGradient>
            </defs>
        </svg>
    );
};

export default CircularProgressSvg;